module.exports = __webpack_public_path__ + "img/NewMarker.2f7aeff3.png";